import {Component} from '@angular/core';
import {NgForm} from '@angular/forms/forms';
import {ResidentForSelect} from '../../../../types/data.types';
import {DirectoryService} from '../../../../services/directory.service';
import {ApiClientService} from '../../../../services/api-client.service';
import {AbstractCreateModalComponent} from '../abstract-create-modal';

declare const toastr: any;

@Component({
    selector: 'vendor-create-modal',
    templateUrl: './vendor-create-modal.component.html'
})
export class VendorCreateModalComponent extends AbstractCreateModalComponent {
    residents: Array<ResidentForSelect> = [];
    multiselectSettings = {
        singleSelection: false,
        text: 'Select Corporations',
        selectAllText: 'Select All',
        unSelectAllText: 'Deselect All',
        scrollable: true,
        enableSearchFilter: true,
        classes: 'with-filter'
    };
    serviceAreas = [];
    paymentMethods = [];
    phones = [];
    addresses = [];
    vendors = [];
    corporations = [];

    constructor(
        public directoryService: DirectoryService,
        public api: ApiClientService
    ) {
        super(directoryService, api);
    }

    onSubmit(form: NgForm) {
        if (!form.valid) {
            if (!form.value.name) toastr.warning('Name should not be blank.');
            if (!form.value.description) toastr.warning('Description should not be blank.');
            return;
        }

        if(!this.directoryService.userIsSuperAdmin() && (!form.value.corporations || form.value.corporations.length < 1)) {
            toastr.warning('Corporations should not be blank.');
            return;
        }

        const data: any = {
            name: form.value.name,
            description: form.value.description,
            corporations: form.value.corporations.map(c => ({bdId: c.id, name: c.name, number: c.name}))
        };

        this.directoryService.currentTabId = 'vendors';
        const url = this.directoryService.getUrl('post');
        this.api.post('domainVendors', url, data).subscribe(
            (res) => {
                toastr.success('Vendor has been created successfully.');
                this.directoryService.getData();
                this.directoryService.hideModal();
                this.disabledSubmit = false;
            },
            (error) => {
                this.api.errorHandler(error, 'Failed to create Vendor');
                this.disabledSubmit = false;
            }
        );
    }
}



// WEBPACK FOOTER //
// /app/src/app/components/directory/create-modal/vendor-create-modal/vendor-create-modal.component.ts